import React, { Component } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { getBoundingClientRect } from '../../utils/functions';
import { checkTranslation } from '../../utils/useful';
import NavigationBasicItem from './NavigationBasicItem';
import { MenuBuilderObjects } from '../../variables/menuBuilderData';

export default class NavigationItemInfo extends Component {

  render() {
    const { item } = this.props;
    let itemInfo = MenuBuilderObjects[item.type]
    // console.log(this.props.dragInfo)
    return (

      <div className='mb-1' key={item._id} style={{ userSelect: 'none', }}>

        <div className={"py-1" + (item.parent != null ? " br-6 w-100 pld-4" : " br-6 w-100")} style={{ backgroundColor: 'rgba(240, 240, 240, 0.8)', direction: 'ltr', }} >
          {/* <div className='' style={{ width: '5px', height: '5px', backgroundColor: 'red' }} /> */}

          <div className="fields flexcb p-2" style={{ transform: "none", }} >

            <div className='flexc'>
              <div className={" drag-indicator flexcc"} draggable onDragStart={e => this.props.onDragStart(e)} onDrag={(e) => this.props.onDrag(e)} style={{ width: "15px", cursor: "grab" }} >
                <img className="" style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" alt='' />
              </div>

              <div className={" flexcc mx-1"} style={{ width: "15px" }} >
                <img className="" style={{ opacity: 0.8 }} src={itemInfo.icon} width="13px" alt='' />
              </div>
              <div>
                <p className="text-small  text-semibold" style={{ color: '#222' }}>{(checkTranslation(item.information?.label))}</p>
              </div>
            </div>

            <div className="flexc">

              <p className="text-smallest mx-1 text-semibold px-1 opacity-5" style={{ color: '#222' }}>{(checkTranslation(itemInfo?.label))}</p>

              <button onClick={() => { this.props.openEdit(item, this.props.index) }} style={{ width: "15px" }} className="mx-1 cursor-poiner flexcc">
                <img className="" style={{ opacity: 0.8 }} src="/assets/icons/useful/settings.png" width="13px" alt='' />
              </button>

            </div>
          </div>
        </div>
        {item.type == 'dropdown' && (
          <div className='pld-5' >
            <NavigationBasicItem key={item._id} column={item} disableDragOver={this.props.disableDragOver ?? (this.props.dragInfo?.id == item._id)} onDragEndAction={this.props.onDragEndAction} list={this.props.list} width={this.props.width} parent={item._id} updatedata={this.props.updatedata} setDragInfo={this.props.setDragInfo} dragInfo={this.props.dragInfo} updateParent={this.props.updateParent} openEdit={this.props.openEdit} />
          </div>
        )}

      </div>

    );
  }
}